/**
 * @generated SignedSource<<c56e156459b30b63f182e4f6c7389e64>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EmailTemplateList_query$data = {
  readonly emailTemplates: ReadonlyArray<{
    readonly createdAt: any;
    readonly emailTemplateIdentifier: string;
    readonly id: string;
    readonly name: string;
    readonly reusable: boolean;
    readonly sentWithMarketingEmailAt: any | null | undefined;
    readonly updatedAt: any;
    readonly usageCount: number;
  }>;
  readonly " $fragmentType": "EmailTemplateList_query";
};
export type EmailTemplateList_query$key = {
  readonly " $data"?: EmailTemplateList_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"EmailTemplateList_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmailTemplateList_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EmailTemplate",
      "kind": "LinkedField",
      "name": "emailTemplates",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "emailTemplateIdentifier",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "usageCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "reusable",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sentWithMarketingEmailAt",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "03370dcb4f4c9063aa0515293c17d68c";

export default node;
